import React, { useState, useEffect } from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";
// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ShoppingBasketTwoToneIcon from "@material-ui/icons/ShoppingBasketTwoTone";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";

// Components
//React Router (for getting parameters)
import { useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
import Preloader from "../../../components/Preloader/Preloader";

const useStyles = makeStyles({
  card: {
    marginBottom: "1rem",
  },
  cardHeader: {
    borderBottom: "1px solid #33993312",
    padding: "1.3rem 24px 2rem 24px",
  },
  title: {
    marginTop: "0",
    color: "#339933",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  subTitle: {
    fontSize: "0.8rem",
    marginBottom: "0.5rem",
    fontWeight: "700",
    textTransform: "uppercase",
    color: "#9f9f9f",
  },
  infoContainer: {
    marginBottom: "2rem",
    backgroundColor: "#33993312",
    padding: "1rem",
    border: "1.5px solid #33993312",
    borderRadius: "5px",
  },
  infoTitle: {
    fontWeight: "700",
    fontSize: "14px",
  },
  infoContent: {
    fontSize: "14px",
  },
  buttonContainer: {
    textAlign: "right",
    "& button": {
      marginLeft: "0.5rem !important",
    },
  },
  infoTotal: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "1rem",
  },
  infoTotalItem: {
    padding: "0.5rem 1rem",
    border: "1px solid #33993312",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5rem",
    fontWeight: "700",
  },
  infoTotalIcon: {
    marginRight: "0.5rem",
    color: "#4caf50 !important",
  },
  textarea: {
    width: "100%",
    marginTop: "1rem",
  },
});

const ProductPackageView = () => {
  const { idno } = useParams();
  const [soInfo, setSoInfo] = useState(null);
  const classes = useStyles();
  const [posts, setPosts] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [grandTotal, setGrandTotal] = useState(0);
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [packageData, setPackageData] = useState([]);
  const [items, setItems] = useState([]); //data to display in item table
  const [allocations, setAllocations] = useState([]); //data to display in payment table
  const [showPDF, setShowPdf] = useState(false);
  let history = useHistory();
  const [useridNo, setuseridNo] = useState(get_cookies("branchidno"));
  // componentDidMount / document.ready ?
  useEffect(() => {
    if (posts.length > 0) {
      setDownloadFlag(true);
    } else {
      setDownloadFlag(false);
    }
  }, [posts]);
  useEffect(() => {
    dataFilter();
  }, []);
  //search button
  const dataFilter = async () => {
    setDataLoaded(false);
    await axios
      .get(process.env.REACT_APP_API_URL + "get_productPackageview", {
        params: {
          jc_user_id_no: useridNo,
          jc_curcode: get_cookies("curcode"),
          idno: idno,
        },
      })
      .then((res) => {
        // console.log("12", res.data.data);
        setPosts(res.data.data);
        setGrandTotal(res.data.grandtotal);
        setPackageData(res.data.packagename);
      })
      .catch((error) => {
        // console.log(error.message);
      });
    setDataLoaded(true);
  };

  const data = async () => {
    setDataLoaded(true);
  };
  const columns = [
    {
      name: "itemid",
      label: "ID",
    },
    {
      name: "itemname",
      label: "Item Name",
    },
    {
      name: "qty",
      label: "Qty",
    },
    {
      name: "uom_description",
      label: "Unit",
    },
    {
      name: "itemprice",
      label: "Price",
    },
    {
      name: "rowtotal",
      label: "Total",
    },
  ];

  const options = {
    filter: false,
    // filterType: "dropdown",
    selectableRows: "none",
    filterType: "multiselect",
    responsive: "standard",
    download: false, //add this
    print: false, //add this
    viewColumns: false,
    setFilterChipProps: (colIndex, colName, data) => {
      //console.log(colIndex, colName, data);
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    downloadOptions: {
      filename: "CollectionTransactionHistory.csv", //change filename of csv
    },
    // tableBodyHeight,
  };

  const style = {
    marginBottom: "1rem",
    marginTop: "2.5em",
  };

  const x = 0;
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        <NavLink to={"/sales"}>
          <h2 style={{ color: "black" }}>Settings</h2>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <NavLink to={"/settings/product-package"}>
          <h2 style={{ color: "black" }}>Product Package</h2>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        {/* <h2>Collection View #{drpayno}</h2> */}
        <h2>#{idno}</h2>
      </div>

      {downloadFlag ? (
        <div className="page-container">
          <Card className={classes.card}>
            <div className={classes.cardHeader}>
              <Grid
                container
                spacing={0}
                style={{ justifyContent: "flex-end" }}
              >
                <Grid item xs={8}>
                  <div className={classes.subTitle}>Product Package Information</div>
                  {/* <div className={classes.title}>Collection View</div> */}
                </Grid>
                <Grid item xs={2} style={{ textAlign: "right" }}></Grid>
                <Grid item xs={2} className={classes.buttonContainer}></Grid>
              </Grid>
            </div>
            <CardContent>
              <div className={classes.infoContainer}>
                <Grid container spacing={3}>
                  <Grid item xs={16} className={classes.infoTitle}>
                  {packageData.description}
                  </Grid>
                  <Grid item xs={8} className={classes.infoContent}>
                    {/* {soInfo.collected_from || "Collected From"} */}
                  </Grid>
                </Grid>
              </div>
            </CardContent>
          </Card>

          {!dataLoaded ? (
            <Preloader />
          ) : (
            <MUIDataTable
              title={
                <div>
                  <h3 className="header-title" style={{ color: "#339933" }}>
                    Product Package
                  </h3>
                </div>
              }
              data={posts}
              columns={columns}
              options={options}
            />
          )}
        </div>
      ) : (
        <Preloader />
      )}
    </div>
  );
};

export default ProductPackageView;
